/**
 * Returns true when the user has an active (non-collapsed) text selection
 * whose anchor lives inside `container`.
 *
 * Checking `container.contains(anchorNode)` avoids a false-positive when
 * stale selected text exists elsewhere on the page.
 */
export function isTextSelected(container: HTMLElement): boolean {
    const selection = window.getSelection();
    if (!selection || selection.isCollapsed) return false;
    return container.contains(selection.anchorNode);
}
